import { render } from "./EditCategories.vue?vue&type=template&id=377d6434&scoped=true"
import script from "./EditCategories.vue?vue&type=script&lang=js"
export * from "./EditCategories.vue?vue&type=script&lang=js"

import "./EditCategories.vue?vue&type=style&index=0&id=377d6434&scoped=true&lang=scss"

import exportComponent from "C:\\projects\\balkan-app\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-377d6434"]])

export default __exports__